@let currentShift = shift();

<div class="flex items-stretch overflow-hidden rounded-md" [style.background-color]="color() | userColorBg">
  <div class="w-xs shrink-0" [style.background-color]="color()"></div>

  <div class="flex grow flex-wrap items-center justify-between gap-sm p-md">
    <div class="flex flex-col">
      <span class="text-base font-bold text-default">{{ currentShift.Shift?.long_name }}</span>

      <span class="text-sm text-support">
        {{ currentShift.starttime | time }} - {{ currentShift.endtime | time }}
      </span>
    </div>

    <ng-content />
  </div>
</div>
